import { graphql } from '~/__gql__/index';

export const mutationRequestDataAndAnalyticsUpsell = graphql(/* GraphQL */ `
  mutation RequestDataAndAnalyticsUpsell {
    requestDataAndAnalyticsUpsell
  }
`);
